import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuid } from "uuid";
import axiosinstances from "../../Helper/useAxios";
import { checkValidateWeight } from "../../utils/comman/Common";

const intialvaluesOfRouting = {
  operator: "",
  supplierId: "",
  weight: 0,
  active: true,
};
export default function MobileRechargeRouting() {
  const navigate = useNavigate();
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const newId = id;
  const unique_id = uuid();
  const [axiosInstance] = axiosinstances();
  const [profileDetails, setProfileDetails] = useState();
  const profileId = useParams();
  const [isupdateRouting, setIsupdateRouting] = useState(false);

  const [dmtDetails, setDmtDetails] = useState({
    name: "",
    requesterId: profileId?.id || null,
    mdn: "",
    roMdn: "",
    clientIdentifier: "",
    password: "",
    clientId: null,
    confirmPayment: false,
    pricingGroupId: "",
    tpsAccEnabled: false,
    tpsAccUrl: {},
    routingTable: [{ ...intialvaluesOfRouting }],
    async: false,
    orderStatusCallback: "",
    encrypted: false,
    defaultSupplierId: "rkit",
  });

  const token = JSON.parse(sessionStorage.getItem("token"));
  const getprofileserviicesresponse = (data) => {
    return axiosInstance
      .get(`/api/v1/retailer/get/${profileId.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "client-id": newId,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((response) => {
        if (response) {
          const { data } = response;
          setProfileDetails(data);
          setDmtDetails((prev) => ({
            ...prev,
            name:
              data?.businessInfo?.name !== undefined
                ? data?.businessInfo?.name
                : "",
          }));
        }
        return false;
      })
      .catch((err) => {
        //console.log(err);
      });
  };

  const addSlab = (index) => {
    setDmtDetails({
      ...dmtDetails,
      routingTable: [
        ...dmtDetails.routingTable,
        {
          ...intialvaluesOfRouting,
        },
      ],
    });
  };

  const removeSlab = (index) => {
    let tempSlab = [...dmtDetails.routingTable];
    var filtered =
      tempSlab !== undefined &&
      tempSlab.filter(function (value, ind) {
        return ind !== index;
      });
    const changedData = filtered.map((values, i) => {
      if (i == 0) {
        return values;
      } else {
        return values;
      }
    });
    setDmtDetails({
      ...dmtDetails,
      routingTable: [...changedData],
    });
  };

  const productHandle = (e, index) => {
    let { name, value } = e.target;
    let tempSlab = [...dmtDetails.routingTable];

    if (name === "active") {
      tempSlab[index][name] = e.target.checked;
    } else {
      tempSlab[index][name] = value;
    }

    setDmtDetails({
      ...dmtDetails,
      routingTable: [...tempSlab],
    });
  };

  const getDmtroutingresponse = (data) => {
    return axiosInstance
      .get(`/api/v1/proxy/client-mapping/admin/get/${profileId.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "client-id": newId,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((response) => {
        // console.log('response', response)
        if (response.status == 200) {
          //console.log('res routing', response)
          setIsupdateRouting(true);
          const { data } = response;
          setProfileDetails(data);
          setDmtDetails((prev) => ({
            ...prev,
            ...data,
          }));
          // if((data?.routingTable == undefined) || (data?.routingTable !== undefined && data?.routingTable.length == 0)){

          //   setDmtDetails((prev) => ({
          //     ...prev,
          //     routingTable:[{...intialvaluesOfRouting}]

          //   }));
          // }
        } else if (response?.status == 500) {
          setIsupdateRouting(false);
          console.log("internal server error");
        } else if (response.status == 400) {
          setIsupdateRouting(false);
          console.log("response.status == 400");
        }

        return false;
      })
      .catch((err) => {
        // console.log('error',err);

        setIsupdateRouting(false);
      });
  };
  const profileDetailsPage = () => {
    navigate(`/profile/${profileId?.id}`);
  };
  useEffect(() => {
    if (id !== undefined) {
      getprofileserviicesresponse();
      const values = getDmtroutingresponse();
    }
  }, [id]);
  const handleChange = (e) => {
    let { value, name } = e.target;
    if (value == "true") {
      value = true;
    } else if (value === "false") {
      value = false;
    }
    setDmtDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const tcpChange = (e) => {
    const { value, name } = e.target;
    const urlValue =
      dmtDetails?.tpsAccUrl !== null ? dmtDetails?.tpsAccUrl : {};
    urlValue[name] = value;
    setDmtDetails((prev) => ({
      ...prev,
      tpsAccUrl: urlValue,
    }));
  };

  const date = new Date();
  const createUser = async (roId) => {
    const url = isupdateRouting
      ? `/api/v1/proxy/client-mapping/admin/update`
      : `/api/v1/proxy/client-mapping/admin/create`;
    const response = await axiosInstance
      .post(
        url,
        {
          ...dmtDetails,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          profileDetailsPage();
        } else if (
          res?.response?.status !== undefined &&
          res?.response?.status == 500
        ) {
          toast.error(
            `${
              res?.response?.statusText
                ? res?.response?.statusText + " check mdn"
                : "internal server error check mdn"
            }`
          );
          console.log("internal server error", res?.response?.statusText);
        }
      })
      .catch((err) => {
        console.log("internal server error");
        console.log("err", err);
      });

    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  function checkProperties(obj) {
    for (var key in obj) {
      console.log("key", key, obj[key]);
      if (
        typeof obj[key] !== "number" &&
        typeof obj[key] !== "boolean" &&
        typeof obj[key] !== "object" &&
        obj[key] == "orderStatusCallback" &&
        obj[key] == ""
      ) {
        toast.error(`enter correct values of ${key}`);
        return false;
      }
    }
    return true;
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    const check = dmtDetails.routingTable;
    const checkobjectvalues = await checkProperties(dmtDetails);

    const checkAllvalidation = check.filter(
      (values, index) =>
        values.operator == "" ||
        values.supplierId == "" ||
        (values?.weight !== 0 && !checkValidateWeight(+values.weight))
    );

    const keys = ["operator", "supplierId"];
    const filtered = check.filter(
      (
        (s) => (o) =>
          ((k) => !s.has(k) && s.add(k))(keys.map((k) => o[k]).join("|"))
      )(new Set())
    );

    if (checkAllvalidation.length > 0) {
      toast.error(`Routing slab filed are not filled with correct format`);
    } else if (!checkobjectvalues) {
      console.log("enter vales are not correct");
    } else if (
      checkobjectvalues &&
      check.length == filtered.length &&
      checkAllvalidation.length === 0
    ) {
      createUser();
    } else {
      toast.error(`Routing data is repeating, check again`);
    }
  };
  const salesDetails = () => {
    const slots = "price";
    return (
      dmtDetails?.routingTable !== undefined &&
      Array.isArray(dmtDetails?.routingTable) &&
      dmtDetails.routingTable.map((val, ind, self) => {
        return (
          <div class="pricelist">
            <div class="pricbtn" id={`prcslb${ind + 3}${slots}`}>
              {ind + 1 == self.length && (
                <button
                  type="button"
                  class="add-slab"
                  data-toggle="tooltip"
                  title="Add Slab"
                  onClick={() => addSlab(ind)}
                ></button>
              )}
              {self.length !== 1 && self.length == ind + 1 ? (
                <button
                  type="button"
                  class="remove-slab"
                  data-toggle="tooltip"
                  title="Remove Slab"
                  onClick={() => removeSlab(ind)}
                ></button>
              ) : ind == 0 && self.length == 1 ? (
                ""
              ) : (
                <button
                  type="button"
                  class="remove-slab-one"
                  data-toggle="tooltip"
                  title="Remove Slab"
                  onClick={() => removeSlab(ind)}
                ></button>
              )}
              <button
                type="button"
                class="collapsed"
                data-bs-toggle="collapse"
                data-bs-target={`#slab${ind + 3}${slots}`}
                aria-expanded="true"
                aria-controls={`slab${ind + 3}${slots}`}
              >
                {`Routing ${ind + 1}`}
              </button>
            </div>

            <div
              id={`slab${ind + 3}${slots}`}
              class="collapse"
              aria-labelledby={`prcslb${ind + 3}${slots}`}
              data-bs-parent="#pricesale"
            >
              <div class="slabox">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-check form-switch float-right">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckChecked"
                            checked={val.active}
                            name="active"
                            onChange={(e) => productHandle(e, ind)}
                          />
                          <label
                            class="form-check-label"
                            for="flexSwitchCheckChecked"
                          >
                            Active
                          </label>
                        </div>
                        <div class="prinput">
                          <div class="row">
                            <div class="col-12 col-md-4">
                              <div class="form-floating">
                                <select
                                  class="form-select"
                                  id="operator"
                                  name="operator"
                                  value={val.operator}
                                  onChange={(e) => productHandle(e, ind)}
                                >
                                  <option value="">Select</option>
                                  <option value={"JIO"}>JIO</option>
                                  <option value={"AIRTEL"}>AIRTEL</option>
                                  <option value={"VODAFONE"}>VODAFONE</option>
                                  <option value={"BSNL"}>BSNL</option>
                                  <option value={"BSNLSTV"}>BSNLSTV</option>
                                </select>
                                <label for="operator">Operator</label>
                              </div>
                            </div>
                            <div class="col-12 col-md-4">
                              <div class="form-floating">
                                <select
                                  class="form-select"
                                  id="supplierId"
                                  name="supplierId"
                                  value={val.supplierId}
                                  onChange={(e) => productHandle(e, ind)}
                                >
                                  <option value="">Select</option>
                                  <option value={"rkit"}>rkit</option>

                                  <option value={"buckbox"}>buckbox</option>
                                  <option value={"KUMAR"}>KUMAR</option>
                                  <option value={"indicore"}>indicore</option>
                                  <option value={"wts"}>wts</option>
                                </select>
                                <label for="supplierId">Supplier Id</label>
                              </div>
                            </div>
                            <div class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  type="text"
                                  class="form-control is-invalid"
                                  id="weight"
                                  aria-describedby="weight"
                                  placeholder="Weight ..."
                                  name="weight"
                                  value={val.weight}
                                  onChange={(e) => productHandle(e, ind)}
                                />
                                <label for="weight">Weight</label>
                                {val.weight !== "" &&
                                  +val.weight !== 0 &&
                                  !checkValidateWeight(val.weight) && (
                                    <div id="weight" class="invalid-feedback">
                                      number allow only 0 & greater than 0
                                    </div>
                                  )}
                              </div>
                            </div>

                            <div class="col-12 col-sm-6 text-sm-end"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
    );
  };
  return (
    <div class="mid-contant">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="head" style={{ paddingBottom: 0, marginBottom: 0 }}>
              <h2>Mobile Rech. Routing </h2>
              <p>
                {profileDetails?.businessInfo?.name !== undefined &&
                  profileId?.id !== undefined &&
                  `${profileDetails?.businessInfo?.name} ( ${profileId?.id} )`}
              </p>
            </div>
          </div>

          <div class="col-12">
            <div class="registerbox">
              <div class="row mb-3">
                <div class="col-12 col-lg-7">
                  <form onSubmit={handleSubmit}>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="version"
                            placeholder="version"
                            name="version"
                            onChange={handleChange}
                            value={dmtDetails.version}
                            disabled
                          />
                          <label for="dsid">version</label>

                          {/* {personalDetails.personalInfo.mobile.length > 1 && isMobileCorrect &&	<small style={{color:'red'}} >Enter Valid Mobile Number</small>} */}
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="name"
                            placeholder="Enter Name"
                            name="name"
                            onChange={handleChange}
                            value={dmtDetails.name}
                          />
                          <label for="name">Name</label>
                          {/* {personalDetails.personalInfo.lname.length > 2 && isLnameCorrect &&	<small style={{color:'red'}} >Enter Valid Last Name</small>} */}
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="password"
                            placeholder="Enter password"
                            name="password"
                            onChange={handleChange}
                            value={dmtDetails.password}
                          />
                          <label for="password">Password</label>
                          {/* {personalDetails.personalInfo.lname.length > 2 && isLnameCorrect &&	<small style={{color:'red'}} >Enter Valid Last Name</small>} */}
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="clientIdentifier"
                            placeholder="Enter clientIdentifier"
                            name="clientIdentifier"
                            onChange={handleChange}
                            value={dmtDetails.clientIdentifier}
                          />
                          <label for="clientIdentifier">
                            Client Identifier
                          </label>
                          {/* {personalDetails.personalInfo.lname.length > 2 && isLnameCorrect &&	<small style={{color:'red'}} >Enter Valid Last Name</small>} */}
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="ocall"
                            placeholder="Enter Order status Call"
                            pattern="https?://.+"
                            name="orderStatusCallback"
                            title="Enter correct format of URL"
                            onChange={handleChange}
                            value={dmtDetails.orderStatusCallback}
                          />
                          <label for="ocall">
                            Order Status Callback(Client)
                          </label>
                        </div>
                      </div>

                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <select
                            class="form-select"
                            id="dsid"
                            name="defaultSupplierId"
                            value={dmtDetails.defaultSupplierId}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            <option value={"rkit"}>rkit</option>
                            {/* <option value={"oldservice"}>oldservice</option> */}
                            <option value={"buckbox"}>buckbox</option>
                            <option value={"KUMAR"}>KUMAR</option>
                          </select>
                          <label for="dsid">Default Supplier Id</label>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="mdn"
                            placeholder="Enter Mdn"
                            name="mdn"
                            onChange={handleChange}
                            value={dmtDetails.mdn}
                          />
                          <label for="psid">Mdn</label>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="roMdn"
                            placeholder="Enter roMdn"
                            name="roMdn"
                            onChange={handleChange}
                            value={dmtDetails.roMdn}
                          />
                          <label for="roMdn">Ro Mdn</label>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="pricingGroupId"
                            placeholder="Enter Pricing Group Id"
                            name="pricingGroupId"
                            onChange={handleChange}
                            value={dmtDetails.pricingGroupId}
                          />
                          <label for="roMdn">Pricing Group Id</label>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <select
                            class="form-select"
                            id="confirmPayment"
                            name="confirmPayment"
                            onChange={handleChange}
                            value={dmtDetails.confirmPayment}
                          >
                            <option value="">Select</option>
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </select>
                          <label for="confirmPayment">Confirm Payment</label>
                        </div>
                      </div>

                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <select
                            class="form-select"
                            id="async"
                            name="async"
                            onChange={handleChange}
                            value={dmtDetails.async}
                          >
                            <option value="">Select</option>
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </select>
                          <label for="async">Async</label>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <select
                            class="form-select"
                            id="encrypted"
                            name="encrypted"
                            onChange={handleChange}
                            value={dmtDetails.encrypted}
                          >
                            <option value="">Select</option>
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </select>
                          <label for="encrypted">Encrypted</label>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <select
                            class="form-select"
                            id="tpsAccEnabled"
                            name="tpsAccEnabled"
                            onChange={handleChange}
                            value={dmtDetails.tpsAccEnabled}
                          >
                            <option value="">Select</option>
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </select>
                          <label for="tpsAccEnabled">
                            3rd Party Accounting Enabled
                          </label>
                        </div>
                      </div>

                      {dmtDetails.tpsAccEnabled && (
                        <div class="col-12 col-md-6">
                          <div class="form-floating">
                            <input
                              type="text"
                              class="form-control"
                              id="debit"
                              placeholder="Enter Debit url"
                              name="debit"
                              onChange={tcpChange}
                              value={
                                dmtDetails?.tpsAccUrl?.debit !== undefined
                                  ? dmtDetails?.tpsAccUrl?.debit
                                  : ""
                              }
                            />
                            <label for="debit">Debit URL</label>
                          </div>
                        </div>
                      )}

                      {dmtDetails.tpsAccEnabled && (
                        <div class="col-12 col-md-6">
                          <div class="form-floating">
                            <input
                              type="text"
                              class="form-control"
                              id="refund"
                              placeholder="Enter Refund url"
                              name="refund"
                              onChange={tcpChange}
                              value={
                                dmtDetails?.tpsAccUrl?.refund !== undefined
                                  ? dmtDetails?.tpsAccUrl?.refund
                                  : ""
                              }
                            />
                            <label for="refund">Refund URL</label>
                          </div>
                        </div>
                      )}

                      {dmtDetails.tpsAccEnabled && (
                        <div class="col-12 col-md-6">
                          <div class="form-floating">
                            <input
                              type="text"
                              class="form-control"
                              id="enquiry"
                              placeholder="Enter Enquiry"
                              name="enquiry"
                              onChange={tcpChange}
                              value={
                                dmtDetails?.tpsAccUrl?.enquiry !== undefined
                                  ? dmtDetails?.tpsAccUrl?.enquiry
                                  : ""
                              }
                            />
                            <label for="enquiry">Enquiry</label>
                            {/* { personalDetails.personalInfo.email.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
                          </div>
                        </div>
                      )}

                      <div
                        class="prconfig"
                        id="pricebox2"
                        // style={{ display: "none" }}
                      >
                        <div class="pricbox" id="pricesale">
                          {salesDetails()}
                        </div>
                      </div>

                      <div class="col-12">
                        <button type="submit" class="btn btn-primary" id="">
                          Submit
                        </button>
                        <button
                          onClick={() => profileDetailsPage()}
                          style={{
                            marginTop: "30px",
                            marginLeft: "10px",
                            height: "48px",
                            border: "none",
                          }}
                          type="button"
                          class="btn btn-secondary"
                          id=""
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div class="col-12 col-lg-5 d-none d-lg-block">
                  <div class="rightbanner">
                    <img
                      src={require("../../assests/images/register.png")}
                      alt="Oxigen"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
